module.exports = __webpack_public_path__ + "img/carousel01.b0571a65.webp";